import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

export const StyledTableCell = styled(TableCell)({
  width: '50%',
  verticalAlign: 'top',
  position: 'relative'
});

export const StyledPromptDescription = styled('div')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875em',
  whiteSpace: 'pre-line'
}));



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/styles.js